export const ADMIN_ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',
  INSTITUTES: '/institutes',
  FEATURE_FLAGS: '/feature-flags',
  SUPPORT_TICKETS: '/support-tickets',
  SUPPORT_TICKET_DETAIL: '/support-tickets/:id',
  AUDIT_LOGS: '/audit-logs',
  ROLES: '/roles',
  CACHE: '/cache',
  PLANS: '/plans',
  SYSTEM_CONFIG: '/system-config',
} as const;
